<!--
 * @Author: louhexi
 * @Date: 2024-06-28 14:50:48
 * @LastEditors: louhexi
 * @LastEditTime: 2024-07-26 17:04:39
 * @Description: 当前文件描述
-->
<template lang="html">
<!--        模块预览 -->
    <cc-preview-module
        title="代理人"
        :data="transformData"></cc-preview-module>
</template>

<script>
    // 预览模块
    import ccPreviewModule from '@/components/common/preview-module/index.vue';
    // 数据转换
    import transformData from '@/views/mixins/transform-data.js';
    // 请求request
    import request from '../mixins/request.js'
    // 工具类
    import utils from '../js/utils.js';

    export default {
        mixins: [transformData, request],
        components: {
            ccPreviewModule
        },
        // 注入
        inject: ['fyid'],
        props: {
            // 申请人数据列表
            sqrData: {
                type: Array
            }
        },
        data() {
            return {
                // 转换后的数据
                transformData: []
            }
        },
        computed:{},
        methods: {
            /**
             * 获取原告代理人列表
             * @returns {void}
             * */
            getYgdlrList() {
                // 请求代理人数据
                this.requestDlrData(this.fyid).then(dlrDataList => {
                    this.transformData = this.getTransformData(dlrDataList);
                });
            },

          getYgdlrListxq() {
            // 请求代理人数据
            this.requestDlrData(this.fyid).then(dlrDataList => {
              this.transformData = this.getTransformData(dlrDataList);
            });
          },

            /**
             * 获取转换之后的数据
             * @param {Array<Object>} data 数据来源列表
             * @returns {Array} 转换后的数据列表
             * */
            getTransformData(data) {
                const _transformData = [];
                // 循环遍历组装数组
                data.forEach(itemData => {
                    const _transformItemData = [];
                    _transformItemData.push(this.getRowData('所属原告', utils.getDlrSsygMc(itemData.cBqfySqrids, this.sqrData), false, true));
                    _transformItemData.push(this.getRowData('代理人类型', itemData.cDlrlxText));
                    _transformItemData.push(this.getRowData('代理人姓名', itemData.cDlrxm));
                    _transformItemData.push(this.getRowData('性别', itemData.cDlrxbText));
                    _transformItemData.push(this.getRowData('证件类型', itemData.cDlrzjlxText));
                    _transformItemData.push(this.getRowData('证件号码', itemData.cDlrzjh, false, true));
                    _transformItemData.push(this.getRowData('手机号码', itemData.cPhone));
                    //
                    if (itemData.cDlrlx === '1') {
                        _transformItemData.push(this.getRowData('执业证件号码', itemData.cDlrzjhm, false, true));
                        _transformItemData.push(this.getRowData('代理人所在律所', itemData.cDlrszls, false, true));
                    }
                    _transformItemData.push(this.getRowData('固定电话', itemData.cGddh));
                    _transformData.push(_transformItemData);
                })
                return _transformData;
            }
        },
        created() {
            // 获取代理人列表
            this.getYgdlrList()
        }
    }
</script>

<style lang="less" scoped>
    .ygdlr-box {
        position: relative;
    }
    .ssyg-test{
        position: absolute;
        right: 20px;
        top: 15px;
        color: #333 !important;
        z-index: 99;
        width:210px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        display:inline-block;
        text-align:right;
    }
</style>
